// extracted by mini-css-extract-plugin
export var footer = "_on-0";
export var inherit = "_on-1";
export var input = "_on-2";
export var modalContent = "_on-3";
export var quillEditor = "_on-4";
export var subtitle = "_on-5";